import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import logo from "../images/logo.svg";
import { API_URL } from "../config";

const rsoDynamicTargetStorageKey = 'rso-dynamic-menu-target';

const defaultRsoPageServices = [
    {
        title: 'Оперативные данные',
        activeTab: 'Динамическая информация',
        dynamicActiveTab: 'Оперативные данные',
    },
    {
        title: 'Дневной отчет',
        activeTab: 'Динамическая информация',
        dynamicActiveTab: 'Дневной отчет',
    },
    { title: 'Отчет за дату', activeTab: 'Отчет за дату' },
    { title: 'Отказы оборудования', activeTab: 'Отказы оборудования' },
    { title: 'ВЗУ детально', activeTab: 'ВЗУ детально' },
];

const Header = () => {
    let { user, logoutUser, authTokens } = useContext(AuthContext);
    const [pageServices, setPageServices] = useState([]);
    const headerLeftRef = useRef(null);

    let [profile, setProfile] = useState({
        fare_access: false,
        wear_access: false,
        RSO_access: false,
        ADS_access: false,
        ADS_heat_access: false,
        TControl_access: false
    });

    useEffect(() => {
        getProfile();
    }, []);

    useEffect(() => {
        const updatePageServices = event => {
            setPageServices(event.detail?.items || []);
        };

        window.addEventListener('page-services:update', updatePageServices);
        return () => window.removeEventListener('page-services:update', updatePageServices);
    }, []);

    useEffect(() => {
        const closeMenuOnOutsideClick = event => {
            if (!headerLeftRef.current?.contains(event.target)) {
                isMenuActiveSet(false);
            }
        };

        document.addEventListener('mousedown', closeMenuOnOutsideClick);
        return () => document.removeEventListener('mousedown', closeMenuOnOutsideClick);
    }, []);

    let getProfile = async () => {
        let response = await fetch(API_URL + '/user/profile/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + String(authTokens?.access),
            },
        });
        let data = await response.json();

        if (response.status === 200) {
            setProfile(data[0]);
        }
    };

    const [isDroppedMenu, setIsDroppedMenu] = useState(false);
    const [isMenuActive, isMenuActiveSet] = useState(false);

    const menuActive = () => {
        isMenuActiveSet(!isMenuActive);
    };

    const rsoDynamicJobTitle = profile?.job_title;
    const canOpenRsoDynamic =
        profile?.RSO_access &&
        ["Работник", "Оператор БД", "Технический администратор", "Диспетчер"].includes(rsoDynamicJobTitle);
    const canSeeRsoDynamicSubservices =
        profile?.RSO_access &&
        ["Технический администратор", "Диспетчер"].includes(rsoDynamicJobTitle);

    const rsoPageServices = pageServices.length > 0
        ? pageServices.flatMap(item => (item.children?.length ? item.children : item))
        : defaultRsoPageServices;

    const handleRsoServiceClick = item => {
        if (item.onClick) {
            item.onClick();
        } else {
            sessionStorage.setItem(rsoDynamicTargetStorageKey, JSON.stringify({
                activeTab: item.activeTab,
                dynamicActiveTab: item.dynamicActiveTab,
            }));
        }

        isMenuActiveSet(false);
    };

    const droppedMenu = () => {
        setIsDroppedMenu(!isDroppedMenu);
    };

    const authLinks = (
        <>
            <li>
                <div className='menu__list-box'>
                    <div
                        className={
                            'menu__list-container ' +
                            (isDroppedMenu ? 'menu__list-container--active' : '')
                        }
                    >
                        {profile?.fare_access === true ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv1'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/fare'>
                                    Расчет - обоснование платы
                                </NavLink>
                            </div>
                        ) : (
                            ""
                        )}
                        {profile?.wear_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv2'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/wear'>
                                    Расчет износа жилых зданий
                                </NavLink>
                            </div>
                        ) : (
                            ""
                        )}
                        {profile?.wear_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv10'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/wearbuilding'>
                                    Расчет износа гражданских зданий
                                </NavLink>
                            </div>
                        ) : (
                            ""
                        )}
                        {canOpenRsoDynamic ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv4'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/rso/dynamic'>
                                    РСО Динамик
                                </NavLink>
                            </div>
                        ) : (
                            ""
                        )}

                        {profile?.RSO_access && (profile?.job_title == "Гидрогиолог" || profile?.job_title == "Начальник гидрогиологов") ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv6'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/rso/hydrologist'>
                                    Гидрогеолог
                                </NavLink>
                            </div>
                        ) : (
                            ""
                        )}

                        {profile?.ADS_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv5'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/ads'>АДС Вода</NavLink>
                            </div>) : (
                            ""
                        )}
                        {profile?.ADS_heat_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv5'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/Tads'>АДС Тепло</NavLink>
                            </div>) : (
                            ""
                        )}
                        {/* {profile?.TControl_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv5'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/tcontrol'>ТЕПЛОконтроль</NavLink>
                            </div>) : (
                            ""
                        )} */}
                        {profile?.TControl_access ? (
                            <div className='menu__option'>
                                <input
                                    className='menu__input'
                                    type='radio'
                                    id='serv55'
                                    name='services'
                                />
                                <NavLink className='menu__navlink' to='/services/teplocontrol'>Контроль ТС</NavLink>
                            </div>) : (
                            ""
                        )}

                    </div>
                    <div className='menu__selected' onClick={droppedMenu}>
                        Сервисы
                    </div>
                </div>
            </li>
        </>
    );

    const authHeaderLinks = (
        <ul className='header__list'>
            <li className='header__list-item'>
            </li>
            <li className='header__list-item'>
                <NavLink className='header__list-link' to='/' onClick={logoutUser}>
                    Выход
                </NavLink>
            </li>
        </ul>
    );

    const guestLinks = (
        <>
        </>
    );

    const guestHeaderLinks = (
        <ul className='header__list'>
            <li className='header__list-item'>
                <NavLink onClick={() => localStorage.setItem("UserSelect", "Register")} className='header__list-link'
                    to='/login'>
                    Регистрация
                </NavLink>
            </li>
            <li className='header__list-item'>
                <NavLink onClick={() => localStorage.setItem("UserSelect", "Login")} className='header__list-link'
                    to='/login'>
                    Вход
                </NavLink>
            </li>
        </ul>
    );

    return (
        <div className='top'>
            <header className='header'>
                <div className='container'>
                    <div className='header__inner'>
                        <div className='header__left' ref={headerLeftRef}>
                            <div className='header__burger'>
                                <button
                                    onClick={menuActive}
                                    className={
                                        'menu__btn header__list-link ' + (isMenuActive ? 'menu__btn--active' : '')
                                    }
                                    type='button'
                                >
                                    Меню
                                </button>
                                <div className={'header__burger-menu ' + (isMenuActive ? 'header__burger-menu--active' : '')}>
                                    <NavLink className='header__burger-link' to='/' onClick={() => isMenuActiveSet(false)}>
                                        Главная
                                    </NavLink>

                                    {user ? (
                                        <>
                                            <div className='header__burger-title'></div>
                                            {profile?.fare_access === true ? (
                                                <NavLink className='header__burger-link' to='/services/fare' onClick={() => isMenuActiveSet(false)}>
                                                    Расчет - обоснование платы
                                                </NavLink>
                                            ) : null}
                                            {profile?.wear_access ? (
                                                <>
                                                    <NavLink className='header__burger-link' to='/services/wear' onClick={() => isMenuActiveSet(false)}>
                                                        Расчет износа жилых зданий
                                                    </NavLink>
                                                    <NavLink className='header__burger-link' to='/services/wearbuilding' onClick={() => isMenuActiveSet(false)}>
                                                        Расчет износа гражданских зданий
                                                    </NavLink>
                                                </>
                                            ) : null}
                                            {canSeeRsoDynamicSubservices ? (
                                                <div className='header__burger-group'>
                                                    <div className='header__burger-section'>РСО Динамик</div>
                                                    <div className='header__burger-submenu'>
                                                        {rsoPageServices.map(item => (
                                                            <NavLink
                                                                key={item.title}
                                                                className={'header__burger-link header__burger-link--button ' + (item.active ? 'header__burger-link--active' : '')}
                                                                to='/services/rso/dynamic'
                                                                onClick={() => handleRsoServiceClick(item)}
                                                            >
                                                                {item.title}
                                                            </NavLink>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : canOpenRsoDynamic ? (
                                                <NavLink className='header__burger-link' to='/services/rso/dynamic' onClick={() => isMenuActiveSet(false)}>
                                                    РСО Динамик
                                                </NavLink>
                                            ) : null}
                                            {profile?.RSO_access && (profile?.job_title == "Гидрогеолог" || profile?.job_title == "Начальник гидрогеологов") ? (
                                                <NavLink className='header__burger-link' to='/services/rso/hydrologist' onClick={() => isMenuActiveSet(false)}>
                                                    Гидрогеолог
                                                </NavLink>
                                            ) : null}
                                            {profile?.ADS_access ? (
                                                <NavLink className='header__burger-link' to='/services/ads' onClick={() => isMenuActiveSet(false)}>
                                                    АДС Вода
                                                </NavLink>
                                            ) : null}
                                            {profile?.ADS_heat_access ? (
                                                <NavLink className='header__burger-link' to='/services/Tads' onClick={() => isMenuActiveSet(false)}>
                                                    АДС Тепло
                                                </NavLink>
                                            ) : null}
                                            {profile?.TControl_access ? (
                                                <NavLink className='header__burger-link' to='/services/teplocontrol' onClick={() => isMenuActiveSet(false)}>
                                                    Контроль ТС
                                                </NavLink>
                                            ) : null}
                                        </>
                                    ) : null}
                                    <div className='header__burger-secondary'>
                                        <NavLink className='header__burger-link' to='/news' onClick={() => isMenuActiveSet(false)}>
                                            Новости
                                        </NavLink>
                                        <NavLink className='header__burger-link' to='/rules' onClick={() => isMenuActiveSet(false)}>
                                            Авторские права
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='logo__box'>
                            <Link className='logo__link' to='/'>
                                <img src={logo} alt='logo' />
                            </Link>
                        </div>
                        <div className='' />
                        {user ? authHeaderLinks : guestHeaderLinks}
                    </div>
                </div>
            </header>
        </div>
    );
};

export default Header;
